__turbopack_context__.v({
  "--is-unnamed": "submission-wizard-module-scss-module__tGKujG__--is-unnamed",
  "__entry-details": "submission-wizard-module-scss-module__tGKujG____entry-details",
  "__entry-length": "submission-wizard-module-scss-module__tGKujG____entry-length",
  "__entry-name": "submission-wizard-module-scss-module__tGKujG____entry-name",
  "__entry-thumbnail": "submission-wizard-module-scss-module__tGKujG____entry-thumbnail",
  "__modal-footer": "submission-wizard-module-scss-module__tGKujG____modal-footer",
  "__modal-header": "submission-wizard-module-scss-module__tGKujG____modal-header",
  "__next-button": "submission-wizard-module-scss-module__tGKujG____next-button",
  "__previous-button": "submission-wizard-module-scss-module__tGKujG____previous-button",
  "__step-container": "submission-wizard-module-scss-module__tGKujG____step-container",
  "__step-header": "submission-wizard-module-scss-module__tGKujG____step-header",
  "__step-thumbnail-wrapper": "submission-wizard-module-scss-module__tGKujG____step-thumbnail-wrapper",
  "__submission-wizard-step": "submission-wizard-module-scss-module__tGKujG____submission-wizard-step",
  "__submit-button": "submission-wizard-module-scss-module__tGKujG____submit-button",
  "submission-wizard": "submission-wizard-module-scss-module__tGKujG__submission-wizard",
});
